
import { Component, ChangeDetectionStrategy, input, output, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { PlatformService } from '../../../services/platform.service';
import { NotificationService } from '../../../services/notification.service';

@Component({
  selector: 'app-invite-platform-staff-modal',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule],
  templateUrl: './invite-platform-staff-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InvitePlatformStaffModalComponent {
  private platformService = inject(PlatformService);
  private notificationService = inject(NotificationService);
  // FIX: Explicitly typed the injected FormBuilder to resolve "Property 'group' does not exist on type 'unknown'".
  private fb: FormBuilder = inject(FormBuilder);

  isOpen = input.required<boolean>();
  closeModal = output<void>();
  staffInvited = output<void>();

  inviteForm: FormGroup;
  isSubmitting = signal(false);
  inviteLink = signal<string | null>(null);

  roles = [
      { id: 'platform_accountant', label: 'Platform Accountant (นักบัญชีกลาง)', desc: 'View global financials and mark payouts.' },
      { id: 'platform_auditor', label: 'Platform Auditor (ผู้ตรวจสอบ)', desc: 'Read-only access to global logs and data.' },
      { id: 'platform_admin', label: 'Platform Admin (ผู้ดูแลระบบ)', desc: 'Full control over platform settings and stores.' }
  ];

  constructor() {
    this.inviteForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      role: ['platform_accountant', Validators.required],
    });
  }

  async sendInvite() {
    if (this.inviteForm.invalid) return;
    this.isSubmitting.set(true);
    
    try {
        const { email, role } = this.inviteForm.value;
        const token = await this.platformService.invitePlatformStaff(email, role);
        
        // Construct Invite URL
        const origin = window.location.origin;
        const fullUrl = `${origin}/#/register?token=${token}`;
        this.inviteLink.set(fullUrl);
        
        this.notificationService.showSuccess("Invitation link generated successfully!");
    } catch (e: any) {
        this.notificationService.showError("Invitation failed: " + e.message);
    } finally {
        this.isSubmitting.set(false);
    }
  }

  copyLink() {
      if (this.inviteLink()) {
          navigator.clipboard.writeText(this.inviteLink()!);
          this.notificationService.showInfo("Copied link to clipboard");
      }
  }

  onClose() {
    this.inviteForm.reset({ role: 'platform_accountant' });
    this.inviteLink.set(null);
    this.closeModal.emit();
  }

  onBackdropClick(event: MouseEvent) {
    if (event.target === event.currentTarget) this.onClose();
  }
}
